import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { createVMBox, getMisc } from "../../../apiclients/streamsapi_bridge";

function AddNewVMBox(props) {
  const { t } = useTranslation();
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const navigate = useNavigate();
  const { register, handleSubmit, setError, formState, clearErrors } = useForm({
    defaultValues: {
      name: "",
      extension: "",
      pin: "",
    },
  });
  const { errors, isDirty } = formState;
  async function checkAvailability(e) {
    if (e.target.value.trim() == "") {
      return;
    }
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  const onsubmit = async (data) => {
    let hasError = false;

    // Validate extension length before submitting
    if (data.extension.toString().length < 3) {
      setError("extension", {
        type: "manual",
        message: "Extension must be at least 3 characters",
      });
      hasError = true;
    }

    // Prevent extension starting with 0
    let extensionerror = false;
    if (data.extension.toString().charAt(0) === "0") {
      setError("extension", {
        type: "manual",
        message: "Extension cannot begin with zero (0)",
      });
      extensionerror = true;
      hasError = true;
    }

    // Check availability before submitting
    if (!extensionerror && !checkAvailbility) {
      setError("extension", {
        type: "manual",
        message: "Please select an available extension",
      });
      hasError = true;
    }

    // Prevent PIN starting with 0
    if (data.pin.toString().charAt(0) === "0") {
      setError("pin", {
        type: "manual",
        message: "PIN cannot begin with zero (0)",
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    let updates = {};
    if (isDirty) {
      updates = {
        reqid: 65,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        name: data.name,
        extension: parseInt(data.extension),
        pin: parseInt(data.pin),
      };
      console.log(updates);
      if (props.source && props.source === "vmlanding")
        setIsLoader(true);
      let saverep = await createVMBox(updates);
      if (props.source && props.source === "vmlanding")
        setIsLoader(false);

      let saverepeMsg = await saverep.json();
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        localStorage.setItem(
          "s_message",
          "Voicemail " + data.name + " created successfully."
        );
        props.onClose();
        if (props.onSuccess) {
          props.onSuccess({ ...saverepeMsg, name: data.name }, props.tnode);
          return;
        }
        if (props.source && props.source === "vmlanding") {
          window.location.href = "/vmlanding";
          return;
        }
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
    }
  };
  return (
    <>
      <div>
        <div className="tel-numbers">
          <strong>Voicemail Box Name</strong>
        </div>
        <div className="form pt-1">
          <input
            type="text"
            className="form-control"
            maxLength={20}
            {...register("name", { required: "Name is required" })}
          />
          {errors.name && <p className="text-danger">{errors.name.message}</p>}
        </div>
        <div className="tel-numbers mt-2">
          <strong>{t("extension")}</strong>
        </div>
        <div className="form pt-1">
          <input
            type="text"
            className="form-control"
            onKeyDown={(event) => {
              if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab" && event.key !== "Delete") {
                event.preventDefault();
              }
            }}
            {...register("extension", {
              required: "Extension is required",
              minLength: {
                value: 3,
                message: "Extension must be at least 3 characters",
              },
              maxLength: {
                value: 5,
                message: "Extension must not exceed 5 characters",
              },
            })}
            maxLength={5}
            onChange={(e) => {
              clearErrors("extension");
              setCheckAvailbility(false);

              if (e.target.value.charAt(0) === "0") {
                setError("extension", { message: "Extension cannot begin with zero (0)" });
              } else if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                checkAvailability(e);
              }
            }}
          />
          {errors.extension && (
            <>
              {!checkAvailbility && (
                <>
                  <p className="text-danger">{errors.extension.message}</p>
                </>
              )}

              {checkAvailbility && (
                <p style={{ color: "Green" }} className="clr-red">
                  {errors.extension.message}
                </p>
              )}
            </>
          )}
        </div>
        <div className="tel-numbers mt-2">
          <strong>{t("Pin")}</strong>
        </div>
        <div className="form pt-1">
          <input
            type="text"
            className="form-control"
            onKeyDown={(event) => {
              if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Tab" && event.key !== "Delete") {
                event.preventDefault();
              }
            }}
            {...register("pin", {
              required: "PIN is required",
            })}
            maxLength={6}
            onChange={(e) => {
              if (e.target.value.charAt(0) === "0") {
                setError("pin", { message: "PIN cannot begin with zero (0)" });
              } else {
                clearErrors("pin");
              }
            }}
          />
          {errors.pin && <p className="text-danger">{errors.pin.message}</p>}
        </div>
      </div>
      {isLoader && (
        <div className="d-flex justify-content-center py-3">
          <MDBBtn disabled>
            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
            Loading...
          </MDBBtn>
        </div>
      )}
      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("close")}
        </MDBBtn>
        <MDBBtn
          onClick={(e) => {
            e.preventDefault();
            handleSubmit(onsubmit)();
          }}
        >
          {t("add")}
        </MDBBtn>
      </MDBModalFooter>
    </>
  );
}

export default AddNewVMBox;
